import { render, staticRenderFns } from "./BuyerRouteDuplicateSetting.vue?vue&type=template&id=0cb4f030"
import script from "./BuyerRouteDuplicateSetting.vue?vue&type=script&lang=js"
export * from "./BuyerRouteDuplicateSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports